export const getIsCarregandoRelatorioGestaoDetalhado =
  (state) => state.relatoriosGestao.isCarregandoRelatorioGestaoDetalhado

export const getIsCarregandoRelatorioGestaoResumido =
  (state) => state.relatoriosGestao.isCarregandoRelatorioGestaoResumido

export const getIsCarregandoRelatorioGestaoGeral =
  (state) => state.relatoriosGestao.isCarregandoRelatorioGestaoGeral
